const device = {
  mobile: "(max-width: 767px)",
  tablet: "(max-width: 1023px)",
  laptop: "(max-width: 1439px)",
};

export default device;
